import React from "react";

const ChevronRight = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M8.85535 6.3157C8.38155 6.73482 8.38155 7.41186 8.85535 7.83097L13.5691 12.0007L8.85535 16.1704C8.38155 16.5895 8.38155 17.2665 8.85535 17.6857C9.32916 18.1048 10.0945 18.1048 10.5683 17.6857L16.1446 12.7529C16.6185 12.3338 16.6185 11.6568 16.1446 11.2377L10.5683 6.30495C10.1067 5.89658 9.32916 5.89658 8.85535 6.3157Z"
                fill="white"
            />
        </svg>
    );
};

export default ChevronRight;
